<template>
  <!-- 信用申请待审批列表 -->
  <div class="audit-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="download" @click="downloadTable">
          下载表格
        </a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:specialNo="{ tableRow }">
          <span>{{ tableRow.specialNo.join(', ') }}</span>
        </template>

        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="AUDIT_STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ AUDIT_STATUS_OBJ[tableRow.status].text }}
          </a-tag>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { SEARCH_SCHEMA } from './schema'
import { getLimitList, downloadLimitTable } from './api'
import { formatParamDate } from 'utils/util'
import { CREDIT_TYPE_OBJ } from '../const'
import { AUDIT_STATUS_OBJ } from './const'

export default {
  name: 'limit-list',
  data() {
    const initSearchForm = {
      name: '',
      code: '',
      endTime: '',
      startTime: '',
      id: '',
      source: '',
      sn: '',
      creditType: 1,
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      SEARCH_SCHEMA,
      CREDIT_TYPE_OBJ,
      AUDIT_STATUS_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      approvalOrApply: null, //获取是审批页还是申请页
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'id',
          align: 'center',
          width: 210,
        },
        {
          title: 'CRM流水号',
          dataIndex: 'sn',
          width: 200,
        },
        {
          title: '申请人',
          dataIndex: 'applyPerson',
          width: 120,
        },
        {
          title: '限额生效日',
          dataIndex: 'indateStart',
          align: 'center',
          width: 120,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          align: 'center',
          width: 150,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 250,
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          width: 150,
        },
        {
          title: '原始有效期',
          dataIndex: 'oldIndateEnd',
          align: 'center',
          width: 200,
        },
        {
          title: '申请延期至',
          dataIndex: 'newIndateEnd' ,
          align: 'center',
          width: 200,
        },
        {
          title: '信用类型',
          scopedSlots: { customRender: 'type' },
          align: 'center',
          width: 180,
        },
        {
          title: '审批角色',
          dataIndex: 'applyRole',
          width: 200,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: 100,
        },
        {
          title: '申请来源',
          dataIndex: 'sourceStr',
          // width: 100
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          align: 'center',
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1200 },
    }
  },
  mounted() {
    this._getLimitList(this.initSearchForm)
  },
  methods: {
    async downloadTable() {
      try {
        await downloadLimitTable(this.searchForm)
      } catch (error) {
        console.error(error)
      }
    },
    // 点击查询按钮
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getLimitList(data)
    },
    async _getLimitList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        creditType: 1,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getLimitList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getLimitList(this.searchForm)
    },
    handleView(row) {
      const { id, type, status, companyCode, sn } = row
      this.$router.push({
        path: `/credit-approval/limit/approval-detail/${id}`,
        query: {
          type,
          status,
          companyCode,
          sn,
          approvalOrApply: 1,
        },
      })
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
